// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__UQPwy","title":"ClientReferral_title__1XRQN","itemText":"ClientReferral_itemText__uFerI"};